/**
 * Search-template ESM entry point.
 *
 * Loaded only on the search template via a `{% if template.name == 'search' %}`
 * gate in content-for-footer.liquid. Bundled by esbuild into
 * .build/assets/entry-search.js.
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [EntrySearch]
 */

import { log } from './log.js';
import './search.js';

log('[App] entry-search loaded');
